<template>
    <v-card
    class="overflow-hidden"
    >
      <v-system-bar color="deep-purple darken-3"></v-system-bar>
    <v-app-bar fixed dark elevate-on-scroll >
        <v-toolbar-title>
          <a href="/">
            <v-img
            :src="require('../../assets/nav_innuvex.png')"
            contain
            transition="scale-transition"
            max-width="250"
            to="/"
            />
          </a>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn text @click="$vuetify.goTo('#services')">Servicios</v-btn>
          <v-btn text @click="$vuetify.goTo('#about')">Quienes Somos</v-btn>
          <v-btn text @click="$vuetify.goTo('#clients')">Portafolio</v-btn>
          <v-btn
            v-for="(link, i) in importantLinks"
              :key="i"
              :href="link.href"
              class="subheading mx-3"
              target="_blank"
            icon>
                <v-icon medium>{{ link.icon }}</v-icon>
          </v-btn>
        </v-toolbar-items>
    </v-app-bar>
   </v-card>
</template>

<script>
import {
  mdiFacebook,
  mdiTwitter,
  mdiInstagram
} from '@mdi/js'

export default {
  name: 'Navbar',

  data () {
    return {
      importantLinks: [
        {
          text: 'Twitter',
          href: 'https://twitter.com/innuvex',
          icon: mdiTwitter
        },
        {
          text: 'Instagram',
          href: 'https://instagram.com/innuvex',
          icon: mdiInstagram
        },
        {
          text: 'Facebook',
          href: 'https://fb.com/innuvex',
          icon: mdiFacebook
        }
      ],
      slides: [],
      drawer: false,
      group: null
    }
  },
  watch: {
    group () {
      this.drawer = false
    }
  }
}
</script>
